import PermissionGuard from 'components/Global/PermissionGuard'; // adjust the path if necessary
import GratuityReportComponent from 'components/Report/GratuityReport';

const GratuityReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<GratuityReportComponent />
		</PermissionGuard>
	);
};

export default GratuityReport;
